import { validateAttachments } from "./AWSAPI";
import heic2any from "heic2any"

const MAX_BYTES = 25 * 1024 * 1024; // 25megabytes

export const ensureJpegIfHeic = async (file) => {
  if (!file) return null;
  if (!isHeicLike(file)) return file;

  const jpegBlob = await heic2any({
    blob: file,
    toType: "image/jpeg",
    quality: 0.9
  });

  const blob = Array.isArray(jpegBlob) ? jpegBlob[0] : jpegBlob;

  return new File([blob], fileToJpegName(file.name), { type: "image/jpeg" });
};
export const isHeicLike = (file) => {
  const name = (file?.name || "").toLowerCase();
  const type = (file?.type || "").toLowerCase();
  return (
    type === "image/heic" ||
    type === "image/heif" ||
    name.endsWith(".heic") ||
    name.endsWith(".heif")
  );
};
export const fileToJpegName = (name) => {
  const safe = name || "image.heic";
  return safe.replace(/\.(heic|heif)$/i, "") + ".jpg";
};
async function readHeader(file, length = 32) {
  const buffer = await file.slice(0, length).arrayBuffer();
  return new Uint8Array(buffer);
}





function looksLikePng(h) {
  return (
    h.length >= 8 &&
    h[0] === 0x89 &&
    h[1] === 0x50 &&
    h[2] === 0x4e &&
    h[3] === 0x47 &&
    h[4] === 0x0d &&
    h[5] === 0x0a &&
    h[6] === 0x1a &&
    h[7] === 0x0a
  );
}

function looksLikePdf(h) {
  return (
    h.length >= 4 &&
    h[0] === 0x25 &&
    h[1] === 0x50 &&
    h[2] === 0x44 &&
    h[3] === 0x46
  );
}

function looksLikeHeic(h) {
  if (h.length < 12) return false;

  const isFtyp =
    h[4] === 0x66 &&
    h[5] === 0x74 &&
    h[6] === 0x79 &&
    h[7] === 0x70;

  if (!isFtyp) return false;

  const brand = String.fromCharCode(h[8], h[9], h[10], h[11]);
  return ["heic", "heix", "hevc", "hevx", "mif1", "msf1"].includes(brand);
}

function getExtension(name) {
  const i = name.lastIndexOf(".");
  return i >= 0 ? name.slice(i + 1).toLowerCase() : "";
}
export async function validateFiles(files) {
  if (!files || files.length === 0) {
    return { valid: false, error: "Attachments are required." };
  }

  for (const file of files) {
    if (!file) {
      return { valid: false, error: "Invalid file." };
    }

    if (file.size <= 0) {
      return { valid: false, error: "File is empty." };
    }

    if (file.size > MAX_BYTES) {
      return {
        valid: false,
        error: "File exceeds maximum size of 25MB."
      };
    }

    const ext = getExtension(file.name);
    if (ext !== "png" && ext !== "pdf") {
      return {
        valid: false,
        error: "Only files with .png or .pdf extensions are supported."
      };
    }

    let header;
    try {
      header = await readHeader(file, 32);
    } catch {
      return {
        valid: false,
        error: "Unable to read file."
      };
    }

    if (looksLikeHeic(header)) {
      return {
        valid: false,
        error: "HEIC/HEIF files are not supported."
      };
    }

    const isPng = looksLikePng(header);
    const isPdf = looksLikePdf(header);

    if (!isPng && !isPdf) {
      return {
        valid: false,
        error: "Only valid PNG or PDF files are allowed."
      };
    }
  }

  return { valid: true };
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result;

      // Remove "data:xxx;base64," prefix
      const base64 = result.split(",")[1];
      resolve(base64);
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
export const validateFilesSnow = async (files) => {
  const payload = await buildPayload(files);
  const response = await validateAttachments(payload);
  return response;

};
export async function buildPayload(files) {
  if (!files || files.length === 0) {
    return { files: [] };
  }

  const payloadFiles = await Promise.all(
    files.map(async (file) => {
      if (!file) return null;

      const base64 = await fileToBase64(file);

      return {
        filename: file.name,
        content_type: file.type || "application/octet-stream",
        base64EncodedData: base64,
        error: null
      };
    })
  );

  return {
    files: payloadFiles.filter(Boolean)
  };
}